import React, {useState} from 'react';
import {TextField} from 'mui-rff';
import {IconButton, InputAdornment} from "@mui/material";
import {Icon} from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';

/* eslint-disable */
export const PasswordField = ({label, name, ...rest}: any): any => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <TextField
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                            <Icon icon={showPassword ? eyeFill : eyeOffFill}/>
                        </IconButton>
                    </InputAdornment>
                )
            }}
            type={showPassword ? 'text' : 'password'}
            label={label}
            name={name}
            {...rest}
        />
    )
}

export default PasswordField;
